import zIndex from "@material-ui/core/styles/zIndex";
import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

export default class SelectInputDashboard extends React.Component {
	constructor(props) {
		super(props);

		this.selectRef = React.createRef();
		this.state = {
			value: this.props.value ? this.props.value : [],
			hide: true,
		};
	}

	getValue() {
		let value = this.selectRef.current.state.value;
		if (Array.isArray(value) == false) return [value];
		return value;
	}

	handleChange(selectedOption) {
		this.setState({ value: selectedOption });
		this.props.onChange(selectedOption);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			this.setState({ value: this.props.value });
		}
	}

	render() {
		const animatedComponents = makeAnimated();
		const arrow = this.props.hidable == true ? "  ᐁ" : "";

		const customStyles = {
			multiValueLabel: (provided, state) => ({
				...provided,
				width: "100%",
				"white-space": "break-spaces",
				borderBottom: "1px dotted pink",
			}),
			menuPortal: base => ({ ...base, zIndex: 9999 }),
			menu: base => ({ ...base, zIndex: 9999 }),
		};

		return (
			<div style={mainClass}>
				{this.props.name ? (
					<div onClick={() => this.setState({ hide: !this.state.hide })} style={name}>
						{this.props.name + arrow}
					</div>
				) : null}

				<div style={{ display: this.props.hidable == true && this.state.hide == true ? "none" : "block" }}>
					<Select
						ref={this.selectRef}
						style={{ width: "300px" }}
						styles={customStyles}
						closeMenuOnSelect={true}
						components={animatedComponents}
						onChange={this.handleChange.bind(this)}
						defaultValue={[]}
						value={this.state.value}
						isMulti={this.props.isMulti}
						options={this.props.options ?? []}
						menuPortalTarget={document.body}
						menuPosition="fixed"
						placeholder={this.props.placeholder ?? "Seleziona"}
						getOptionLabel={option => option.label}
						getOptionValue={option => option.id} // Garantire l'uso dell'id come valore dell'opzione
					/>
				</div>
			</div>
		);
	}
}

const mainClass = {
	padding: "5px",
	width: "300px",
};

const name = {};

const inputText = {
	width: "300px",
	padding: "10px",
};

const inputTextDisabled = {
	background: "#eeeeee",
	width: "300px",
	padding: "10px",
};
